export const convertToTimezone = (dateString: string, timezoneId: string) => {
    const date = new Date(dateString);

    return new Intl.DateTimeFormat('en-US', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
        timeZone: timezoneId,
    }).format(date);
};
